function e(e){return new Date(e)}export{e as toLocalTimezone};
